import { render, staticRenderFns } from "./mini-program-message-release.vue?vue&type=template&id=30f97f12&scoped=true"
import script from "./mini-program-message-release.vue?vue&type=script&lang=js"
export * from "./mini-program-message-release.vue?vue&type=script&lang=js"
import style0 from "./mini-program-message-release.vue?vue&type=style&index=0&id=30f97f12&prod&scoped=true&lang=css"
import style1 from "./mini-program-message-release.vue?vue&type=style&index=1&id=30f97f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f97f12",
  null
  
)

export default component.exports